/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>交易订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">
      <el-form :inline="true" style="margin-top: 20px;">
        <el-form-item>
          <el-input size="small" v-model="mobile" placeholder="请输入用户手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input size="small" v-model="orderNumber" placeholder="请输入订单编号" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="处理状态：">
          <el-select size="small" v-model="status" placeholder="请选择处理状态">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
        </el-form-item>
      </el-form>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;" v-horizontal-scroll>

      <el-table-column align="center" sortable type="index" label="序号"></el-table-column>
      <el-table-column align="center" sortable prop="orderNumber" label="订单号" width="210" show-overflow-tooltip>
      </el-table-column>

      <el-table-column align="center" prop="mobile" label="用户手机号" width="100">

      </el-table-column>
      <el-table-column align="center" prop="orderPrice" label="订单金额" width="100">
      </el-table-column>
      <el-table-column align="center" prop="buyCount" label="购买数量" width="100">
      </el-table-column>
      <el-table-column align="center" prop="commodityImage" label="商品图" width="105">
        <template slot-scope="scope">
          <el-image style="width: 80px; height: 80px;" :src="scope.row.commodityImage"
            :preview-src-list="[scope.row.commodityImage]"></el-image>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable label="商品名称" prop="commodityName" width="200"></el-table-column>
      <el-table-column align="center" sortable prop="entity" label="商品类型" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.entity == 0">虚拟</div>
          <div v-if="scope.row.entity == 1">实体</div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="type" label="货币类型" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.type == 0">奖学金</div>
          <div v-if="scope.row.type == 1">钻石</div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="status" label="订单状态" width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">待发货</div>
          <div v-if="scope.row.status == 1">待收货</div>
          <div v-if="scope.row.status == 2">已完成</div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="createTime" label="创建时间" width="180" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="tofahuo(scope.row)" v-if="scope.row.status === 0">去发货</el-button>
          <el-button v-if="scope.row.status === 1" size="mini" type="info" disabled>已发货</el-button>
          <el-button v-if="scope.row.status === 2" size="mini" type="info" disabled>已完成</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
import { getOrderList, tryPost } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      fileList: [],
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },

      orderNumber: "",


      // 导出Excel 字段
      fieldsList: {
        "订单号": "orderNumber",    //常规字段
        "手机号": "mobile",
        "消耗积分": "integral",
        "商品名称": "commodity_title",
        "订单状态": "status",
        "消耗积分": "integral",
        "核销店铺": "station_name",
        "核销时间": "delivery_time",
        "创建时间": "creation_time"

      },
      options: [{
        value: -1,
        label: '全部'
      }, {
        value: 0,
        label: '待发货'
      }, {
        value: 1,
        label: '待收货'
      }, {
        value: 2,
        label: '已完成'
      }],
      mobile: '',
      orderNumber: '',
      status: -1,



    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getOrderListS(1)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 去发货
    tofahuo(row) {
      this.$confirm("确定发货吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        let data = {
          id: row.id,
          track: row.track,
        }
        tryPost(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getOrderListS(1)
          } else {
            this.$message.error(res.msg)
          }
        })

      }).catch((err) => {
        this.$message({
          type: "info",
          message: "已取消发货",
        });
      });
    },
    // 获取订单列表
    getOrderListS(page) {
      this.loading = true;
      var parameter = {
        page: (page - 1) * 20,
        mobile: this.mobile,
        orderNumber: this.orderNumber,
        status: this.status,
      };
      getOrderList(parameter).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.listData = res.data.list
          this.pageparm.currentPage = page
          this.pageparm.total = res.data.count
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      });
    },

    callFather(parm) {
      this.pageparm.page = parm.currentPage
      this.getOrderListS(parm.currentPage)
    },
    // 搜索数据
    search() {
      this.getOrderListS(1)
    },
    // 重置数据
    chongzhi() {
      this.mobile = ''
      this.orderNumber = ''
      this.status = -1
      this.getOrderListS(1)
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      this.orderInfo = row;
      this.getOrderDetails()
    },


  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/pay/Order.vue